import { createRoute, redirect } from '@tanstack/react-router'

import { PERMISSIONS } from '@forto-dev/auth-sdk-models'

import { getPermissionsFromToken, hasPermission } from '@/features/auth'
import { rootRoute } from '@/routes/root'
import { getCurrentToken } from '@/utils/auth'
import { ensureAuthenticatedUser, EnsureAuthenticatedUserProps } from '@/utils/auth-wall'
import { Features } from '@/utils/featureFlag/features'

export const companyUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/users',
  beforeLoad: async (props: EnsureAuthenticatedUserProps) => {
    await ensureAuthenticatedUser(props)
    if (!hasPermission(getPermissionsFromToken(getCurrentToken()), PERMISSIONS.CUSTOMERS.USERS.READ)) {
      throw redirect({ to: '/' })
    }
  },
}).lazy(() => import('./users').then((d) => d.Route))

export const companyUsersSsoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/users/sso',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isReady && !context.isCustomerActive) {
      throw redirect({ to: '/' })
    }
    if (context.isFeatureEnabled && !context.isFeatureEnabled(Features.SSO_SELF_SERVICE)) {
      throw redirect({ to: '/company/users' })
    }
    if (!hasPermission(getPermissionsFromToken(getCurrentToken()), PERMISSIONS.CUSTOMERS.SSO.READ)) {
      throw redirect({ to: '/company/users' })
    }
  },
}).lazy(() => import('./sso/sso').then((d) => d.Route))
